<template>
    <div class="login-bg">
        <div class="login-container">
            <div class="left">
                <img src="../../assets/login_left.png" alt="">
            </div>
            <div class="right">
                <div class="site_name"> {{ cfg.app_name }}</div>
                <form class="layui-form">
                    <div class="form_item">
                        <input placeholder="管理员名/手机号" v-model="r.admin_name">
                    </div>

                    <div class="form_item">
                        <input placeholder="登录密码" v-model="r.password" type="password">
                    </div>
                    <div class="form_item">
                        <input placeholder="请输入图形验证码" v-model="r.code">
                        <div @click="_recode">
                            <ls-captcha :code="code"></ls-captcha>
                        </div>
                    </div>
                    <div class="form_item">
                        <a class="loginin flex" style="width:100%;justify-content: center;" @click="_login">登录</a>
                    </div>
                    <div class="a c-primary center mt-20" style="text-align: center;" @click="_to_url(`/reg`)">
                        注册
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            r: {
                code: ''
            },
            code: "",
            codes: "0123456789abcdwerwshdje",
            cfg: {},
        };
    },
    created() {
        this._recode();
        this._config(['app_name']);
    },
    methods: {
        _recode() { //
            this.code = "";
            this.r.code = '';
            this._code(this.codes, 4);
        },
        _rnum(min, max) {
            max = max + 1
            return Math.floor(Math.random() * (max - min) + min)
        },
        // 随机生成验证码字符串
        _code(data, len) {
            for (let i = 0; i < len; i++) {
                this.code += data[this._rnum(0, data.length - 1)]
            }
        },
        _login() {
            if (this.r.code != this.code) {
                this.$message.error('验证码错误');
                return;
            }
            this.$http.post('admin/login', this.r).then(res => {
                if (res.code) {
                    this._vuex('token', res.data.token);
                    location.href = '/v/index.html';
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>